/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class CrmTasksAPI extends ApiClient {
  constructor() {
    super('crm_tasks', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  slaSummary(params = {}) {
    return axios.get(resourcePath(this.url, 'sla_summary'), {
      ...requestConfig(),
      params,
    });
  }

  update(id, payload = {}) {
    return axios.patch(
      resourcePath(this.url, id),
      { crm_task: payload },
      requestConfig()
    );
  }

  complete(id) {
    return axios.post(
      resourcePath(this.url, id, 'complete'),
      {},
      requestConfig()
    );
  }

  cancel(id) {
    return axios.post(
      resourcePath(this.url, id, 'cancel'),
      {},
      requestConfig()
    );
  }

  reopen(id) {
    return axios.post(
      resourcePath(this.url, id, 'reopen'),
      {},
      requestConfig()
    );
  }

  assign(id, payload = {}) {
    return axios.post(
      resourcePath(this.url, id, 'assign'),
      { crm_task: payload },
      requestConfig()
    );
  }

  acknowledgeSlaBreach({ taskId, breachId, reason }) {
    return axios.post(
      resourcePath(this.url, taskId, 'sla_breaches', breachId, 'acknowledge'),
      { reason },
      requestConfig()
    );
  }

  recoverSlaBreach({ taskId, breachId, reason }) {
    return axios.post(
      resourcePath(this.url, taskId, 'sla_breaches', breachId, 'recover'),
      { reason },
      requestConfig()
    );
  }
}

export default new CrmTasksAPI();
